import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import {
  Avatar,
  ButtonBase,
  Menu,
  MenuItem,
  AppBar,
  Box,
  Button,
  Divider,
  IconButton,
  Link,
  Toolbar,
} from '@mui/material';
import { ChevronDown as ChevronDownIcon } from 'react-feather';
import MenuIcon from '../icons/Menu';
import useAuth from '../hooks/useAuth';
import useTrainer from '../hooks/useTrainer';
import Logo from './Logo';

const LoggedInButtons = () => {
  const { data } = useTrainer();

  if (!data) {
    return <></>;
  }

  const slug = data?.webPage?.slug;

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: {
          md: 'flex',
          xs: 'none',
        },
      }}
    >
      <Link
        color="textSecondary"
        component={RouterLink}
        to={`/${slug}/dashboard`}
        underline="none"
        variant="body1"
      >
        Dashboard
      </Link>
      <Divider
        orientation="vertical"
        sx={{
          height: 32,
          mx: 2,
        }}
      />
      <Link
        color="textSecondary"
        component={RouterLink}
        to={`/${slug}/posts`}
        underline="none"
        variant="body1"
      >
        Community Posts
      </Link>
      <Divider
        orientation="vertical"
        sx={{
          height: 32,
          mx: 2,
        }}
      />
      <Link
        color="textSecondary"
        component={RouterLink}
        to={`/${slug}/training_plans`}
        underline="none"
        variant="body1"
      >
        Training Programs
      </Link>
      <Divider
        orientation="vertical"
        sx={{
          height: 32,
          mx: 2,
        }}
      />
    </Box>
  );
};

const NotLoggedInButtons = () => {
  const { data } = useTrainer();

  if (!data) {
    return <></>;
  }

  const slug = data?.webPage?.slug;

  return (
    <>
      <Link component={RouterLink} to={`${slug}/login`} variant="body1">
        <Button color="primary" variant="outlined">
          Login
        </Button>
      </Link>
      <Divider
        orientation="vertical"
        sx={{
          height: 32,
          mx: 2,
        }}
      />

      <Link
        color="textSecondary"
        component={RouterLink}
        to={`/${slug}/signup`}
        variant="body1"
      >
        <Button color="primary" variant="contained">
          Signup
        </Button>
      </Link>
    </>
  );
};

const Account = (props) => {
  const ref = useRef(null);
  const auth = useAuth();
  const { data } = useTrainer();
  const [isOpen, setOpen] = useState(false);
  const authLoading = auth.loading;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (authLoading) {
    return <></>;
  }
  if (!data) {
    return <></>;
  }
  const trainerSlug = data?.webPage?.slug;

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
      >
        <Avatar alt="User" src={auth.user.photoURL} />
        <ChevronDownIcon fontSize="small" />
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        keepMounted
        anchorEl={ref.current}
        open={isOpen}
      >
        <MenuItem component={RouterLink} to={`/${trainerSlug}/account`}>
          {auth.user.email}
        </MenuItem>
        <MenuItem component={RouterLink} to="/logout">
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

const MainNavbar = (props) => {
  const { onSidebarMobileOpen } = props;
  const auth = useAuth();
  const { data } = useTrainer();
  const authLoading = auth.loading;

  if (authLoading) {
    return <></>;
  }
  if (!data) {
    return <></>;
  }

  const trainerSlug = data?.webPage?.slug;

  return (
    <AppBar
      elevation={0}
      sx={{
        backgroundColor: 'background.paper',
        color: 'text.secondary',
      }}
    >
      <Toolbar sx={{ minHeight: 64 }}>
        <IconButton
          color="inherit"
          onClick={onSidebarMobileOpen}
          sx={{
            display: {
              md: 'none',
            },
          }}
          size="large"
        >
          <MenuIcon fontSize="small" />
        </IconButton>
        <RouterLink to={`/${trainerSlug}`}>
          <Logo
            sx={{
              display: {
                md: 'inline',
                xs: 'none',
              },
              height: 40,
              width: 40,
            }}
          />
        </RouterLink>
        <Box sx={{ flexGrow: 1 }} />
        <Box
          sx={{
            alignItems: 'center',
            display: {
              md: 'flex',
              xs: 'none',
            },
          }}
        >
          {auth.user && <LoggedInButtons />}
          {auth.user && <Account />}
          {!auth.user && <NotLoggedInButtons />}
        </Box>
      </Toolbar>
      <Divider />
    </AppBar>
  );
};

MainNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func,
};

export default MainNavbar;
